import { Typography } from "@mui/material";

type LabeledProps = {
  title: string | undefined;
  children: React.ReactNode;
};

export const Labeled = ({ title, children }: LabeledProps) => {
  return (
    <>
      <Typography variant="caption" display="block">
        {title}:
      </Typography>
      {children}
    </>
  );
};
